import { Skeleton } from "antd"
import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"

import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"
import { ALBUM_CARD_WITH } from "../album-card-width.ts"
import { AlbumCard } from "../AlbumCard/AlbumCard.tsx"
import { CreateAlbumCard } from "./CreateAlbumCard.tsx"

interface ProjectAlbumsProps {
  albums: AlbumListItem[]
  createAllowed: boolean
  onCreateAlbumClick?: () => void
  hasMore: boolean
  onLoadMore: () => void
  onViewAlbum?: (id: string) => void
  userId: string
  deleteAllowed: boolean
  deleteForeignAllowed: boolean
  onDeleteClick: (albumId: string) => void
  editAllowed: boolean
  onEditClick: (albumId: string) => void
}

export const ProjectAlbums = ({
  albums,
  createAllowed,
  onCreateAlbumClick,
  hasMore,
  onLoadMore,
  onViewAlbum,
  userId,
  deleteAllowed,
  deleteForeignAllowed,
  onDeleteClick,
  editAllowed,
  onEditClick
}: ProjectAlbumsProps) => {
  return (
    <div
      id="albumsScrollableDiv"
      className="overflow-y-auto tailwind-scroll overflow-x-hidden flex-1"
    >
      <InfiniteScroll
        scrollableTarget="albumsScrollableDiv"
        dataLength={albums?.length ?? 0}
        next={onLoadMore}
        hasMore={hasMore}
        loader={
          <div
            style={{
              gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
            }}
            className="grid gap-4"
          >
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton.Node
                key={i}
                active
                style={{ width: "100%", height: "220px" }}
                className="w-full"
              />
            ))}
          </div>
        }
      >
        <div
          style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
          }}
          className="grid gap-4"
        >
          {createAllowed && (
            <div style={{ minHeight: 220 }}>
              <CreateAlbumCard onClick={onCreateAlbumClick} />
            </div>
          )}

          {albums.map((album) => (
            <AlbumCard
              key={album.id}
              album={album}
              onView={onViewAlbum}
              userId={userId}
              deleteAllowed={deleteAllowed}
              deleteForeignAllowed={deleteForeignAllowed}
              onDeleteClick={onDeleteClick}
              editAllowed={editAllowed}
              onEditClick={onEditClick}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  )
}
